import Link from 'next/link';

export function Footer() {
  return (
    <footer className="border-t border-border bg-muted/40 py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <h3 className="mb-4 text-lg font-bold">ValleyTech</h3>
            <p className="text-sm text-muted-foreground">
              أحدث الهواتف والإكسسوارات بأفضل الأسعار في الجزائر
            </p>
          </div>
          <div>
            <h3 className="mb-4 text-lg font-bold">روابط سريعة</h3>
            <ul className="space-y-2">
              <li><Link href="/products" className="text-sm text-muted-foreground hover:text-foreground">جميع المنتجات</Link></li>
              <li><Link href="/about" className="text-sm text-muted-foreground hover:text-foreground">عن فالي تك</Link></li>
              <li><Link href="/contact" className="text-sm text-muted-foreground hover:text-foreground">تواصل معنا</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="mb-4 text-lg font-bold">المساعدة</h3>
            <ul className="space-y-2">
              <li><Link href="/shipping" className="text-sm text-muted-foreground hover:text-foreground">التوصيل</Link></li>
              <li><Link href="/terms" className="text-sm text-muted-foreground hover:text-foreground">الشروط والأحكام</Link></li>
              <li><Link href="/privacy" className="text-sm text-muted-foreground hover:text-foreground">سياسة الخصوصية</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-border pt-4 text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} ValleyTech. جميع الحقوق محفوظة.
        </div>
      </div>
    </footer>
  );
}
